// src/constants/index.ts

export const V = {
  gold: '#C9A84C',
  goldHover: '#D4B85A',
  goldDeep: '#8B6914',
  goldBg: 'rgba(201, 168, 76, 0.08)',
  goldBorder: 'rgba(201, 168, 76, 0.25)',
  goldDim: 'rgba(201, 168, 76, 0.12)',
  card: '#111111',
  wa: '#25D366',

  // Text Colors
  ink: '#F5F5F0',
  ink2: 'rgba(245, 245, 240, 0.90)', // High-impact contrast for production
  ink3: 'rgba(245, 245, 240, 0.85)', // High-impact contrast for production

  // Background Colors
  bg: '#0A0A0A',
  cardBg: '#111111',
  surface: '#1A1A1A',
  deep: '#0D0D0D',

  // Border Colors
  border: 'rgba(245, 245, 240, 0.07)',
  border2: 'rgba(245, 245, 240, 0.14)',

  // Shadows
  shadowSm: '0 2px 8px rgba(0, 0, 0, 0.3)',
  shadowMd: '0 4px 16px rgba(0, 0, 0, 0.4)',
  shadowLg: '0 8px 32px rgba(0, 0, 0, 0.5)',
  shadowGold: '0 8px 32px rgba(201, 168, 76, 0.15)',

  // Border Radius
  radiusSm: '8px',
  radiusMd: '14px',
  radiusLg: '24px',
  radiusXl: '40px',
  radiusFull: '100px',

  // Fonts
  fontDisplay: "'Cormorant Garamond', Georgia, serif",
  fontBody: "'DM Sans', sans-serif",
};

export const TRUST_STATS = {
  familiesServed: '500+',
  countries: '15+',
  responseTime: '< 10 min',
  rating: '4.9★',
  yearsExperience: '15+',
  verifiedReviews: '500+',
};

export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/FarajaMedia/',
  youtube: 'https://www.youtube.com/@FarajaMedia254',
  instagram: 'https://www.instagram.com/farajamedia/',
  linkedin: 'https://www.linkedin.com/company/farajamedia/',
  whatsapp: 'https://wa.me/254721296564',
  googleReview: 'https://g.page/r/CfRUQQ5RmjKMEAI/review',
  googleMaps: 'https://maps.app.goo.gl/YOUR_MAPS_ID',
};

// Site Information
export const SITE_URL = 'https://farajamedia.com';
export const SITE_NAME = 'Faraja Media';
export const WHATSAPP_NUMBER = '254721296564';       // Client-facing booking line
export const OWNER_WHATSAPP_NUMBER = '254721296564'; // ← replace with your real owner number
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;
export const PHONE = '+254 721 296 564';
export const EMAIL = 'info@farajamedia.com';
export const ADDRESS = 'Westlands, Nairobi, Kenya';
export const MPESA_PAYBILL = '247247';
export const MPESA_ACCOUNT = '502401';
export const BUSINESS_NAME = 'C-GEN PIX CREATIVES';

// Utility Functions
export const formatPrice = (amount: number, currency: string = 'KSH'): string => {
  if (currency === 'USD') return `$${Math.round(amount * 0.0078).toLocaleString()}`;
  if (currency === 'GBP') return `£${Math.round(amount * 0.0061).toLocaleString()}`;
  return `KSh ${amount.toLocaleString()}`;
};

export const getWhatsAppLink = (message: string = ''): string => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};

export const getGoogleReviewLink = (): string => {
  return SOCIAL_LINKS.googleReview;
};